import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
//import 'jquery-components/bootstrap-datepicker';
import $ from 'jquery';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { language } from '../appI18n';
const InputValidationMessage = (message, ref) => {
    return {
        onInvalid: () => {
            var _a;
            if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity)
                ref.current.setCustomValidity(message);
        },
        onChange: () => {
            var _a;
            if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity)
                ref.current.setCustomValidity('');
        }
    };
};
export function BootstrapDatePicker(props) {
    var _a;
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    //const displayValue = useMemo(() => props.selected ? ($.fn.datepicker as any).DPGlobal.format(props.selected.toDate().toLocaleDateString(), ($.fn.datepicker as any).defaults.format, language) : undefined, [props.selected])
    //const displayValue = useMemo(() => props.selected ? props.selected.toDate().toLocaleDateString() : undefined, [props.selected])
    useEffect(() => {
        if (!containerRef.current)
            return;
        $(containerRef.current).datepicker(Object.assign({ language: language, 
            //format: 'yyyy-mm-dd',
            startDate: new Date(), orientation: "bottom auto", todayHighlight: true, autoclose: true, keepEmptyValues: true }, (props.datepickerOptions || {})));
        $(containerRef.current).off('clearDate');
        $(containerRef.current).off('changeDate');
        $(containerRef.current).on('clearDate', (e) => {
            if (props.onChange)
                props.onChange(undefined);
        });
        $(containerRef.current).on('changeDate', (e) => {
            if (props.onChange) {
                //props.onChange(e.date ? e.date.toISOString().split('T')[0] : undefined)
                //props.onChange(e.date ? moment(e.date).toDate().toLocaleDateString() : undefined)
                //props.onChange(moment(e.date))
                props.onChange(e.format());
            }
        });
    }, [containerRef.current, props.datepickerOptions]);
    //useEffect(() => {
    //    if (!inputRef.current)
    //        return
    //    $(inputRef.current).selectpicker('refresh')
    //}, [props.disabled, props.required])
    useEffect(() => {
        if (!containerRef.current)
            return;
        $(containerRef.current).datepicker('setDate', props.selected);
        $(containerRef.current).datepicker('refresh');
    }, [props.selected, containerRef.current]);
    //useEffect(() => {
    //    if (!containerRef.current)
    //        return
    //    //$(containerRef.current).datepicker('setDate', props.selected as any)
    //    $(containerRef.current).datepicker('setDate', props.selected?.format((props.datepickerOptions?.format || 'mm/dd/yyyy').toString().toUpperCase()) as any)
    //    setTimeout(() => {
    //        $(containerRef.current!).datepicker('refresh')
    //    }, 200)
    //}, [props.selected, containerRef.current])
    //useEffect(() => {
    //    if (!selectRef.current)
    //        return
    //    $(selectRef.current).selectpicker('refresh')
    //})
    return (React.createElement("div", { className: "input-group date", ref: containerRef },
        React.createElement("label", { htmlFor: "date", className: "input-group-addon input-date datepickerbutton" }),
        React.createElement("input", Object.assign({ ref: inputRef, type: "text", className: "form-control px-0", required: true, maxLength: 10 }, (props.customValidationMessage ? InputValidationMessage(props.customValidationMessage, inputRef) : {}), { value: typeof props.selected == 'string' ? props.selected : (_a = props.selected) === null || _a === void 0 ? void 0 : _a.toISOString().split('T')[0], autoComplete: "off" }, (props.inputProps || {}))),
        React.createElement("label", { htmlFor: "date", className: "input-group-addon datepickerbutton" },
            React.createElement("span", { className: "input-select glyphicon glyphicon-calendar" }))));
}
export function BootstrapDatetimePicker(props) {
    var _a, _b, _c, _d;
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    const selectedValue = (_b = (_a = props.selected) === null || _a === void 0 ? void 0 : _a.format('DD.MM.YYYY')) !== null && _b !== void 0 ? _b : '';
    const [inputValue, setInputValue] = React.useState(selectedValue);
    const propsRef = useRef(props);
    propsRef.current = props;
    //const displayValue = useMemo(() => props.selected ? ($.fn.datepicker as any).DPGlobal.format(props.selected.toDate().toLocaleDateString(), ($.fn.datepicker as any).defaults.format, language) : undefined, [props.selected])
    //const displayValue = useMemo(() => props.selected ? props.selected.toDate().toLocaleDateString() : undefined, [props.selected])
    useEffect(() => {
        if (!containerRef.current || !inputRef.current)
            return;
        $(inputRef.current).datetimepicker(Object.assign({ language: language, format: "DD.MM.YYYY", startDate: props.selected ? moment(props.selected) : undefined, orientation: "bottom auto", todayHighlight: true, autoclose: true, keepEmptyValues: true, minDate: props.minDate, maxDate: props.maxDate, useCurrent: false }, (props.datepickerOptions || {})));
        $(containerRef.current).off("dp.change");
        $(containerRef.current).on("dp.change", function (evt) {
            var _a, _b, _c, _d;
            const picker = $(evt.target).data("DateTimePicker");
            picker.hide();
            const selected = (_a = picker.getDate()) !== null && _a !== void 0 ? _a : undefined;
            setInputValue((_b = selected === null || selected === void 0 ? void 0 : selected.format('DD.MM.YYYY')) !== null && _b !== void 0 ? _b : '');
            if (selected || propsRef.current.selected)
                (_d = (_c = propsRef.current).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, selected);
        });
        //$(containerRef.current).off('clearDate')
        //$(containerRef.current).off('changeDate')
        //$(containerRef.current).on('clearDate', (e: DatepickerEventObject) => {
        //    if (props.onChange)
        //        props.onChange(undefined)
        //})
        //$(containerRef.current).on('changeDate', (e: DatepickerEventObject) => {
        //    if (props.onChange) {
        //        //props.onChange(e.date ? e.date.toISOString().split('T')[0] : undefined)
        //        //props.onChange(e.date ? moment(e.date).toDate().toLocaleDateString() : undefined)
        //        //props.onChange(moment(e.date))
        //        props.onChange(e.format())
        //    }
        //})
    }, [containerRef.current, inputRef.current, props.datepickerOptions]);
    useEffect(() => {
        if (!inputRef.current)
            return;
        $(inputRef.current).unmask();
        if (props.mask)
            $(inputRef.current).mask(...props.mask);
    }, [props.mask, inputRef.current]);
    useEffect(() => {
        var _a, _b;
        setInputValue(selectedValue);
        if (inputRef.current)
            (_a = $(inputRef.current).data("DateTimePicker")) === null || _a === void 0 ? void 0 : _a.setValue((_b = props.selected) !== null && _b !== void 0 ? _b : null);
    }, [selectedValue]);
    const handleInputChange = (event) => {
        var _a, _b, _c, _d, _e;
        const value = event.currentTarget.value;
        setInputValue(value);
        event.currentTarget.setCustomValidity('');
        if (!value.trim()) {
            (_a = $(event.currentTarget).data("DateTimePicker")) === null || _a === void 0 ? void 0 : _a.setValue(null);
            if (propsRef.current.selected)
                (_c = (_b = propsRef.current).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, undefined);
        }
        (_e = (_d = props.inputProps) === null || _d === void 0 ? void 0 : _d.onChange) === null || _e === void 0 ? void 0 : _e.call(_d, event);
    };
    return (React.createElement("div", { className: "input-group date", ref: containerRef },
        React.createElement("label", { htmlFor: props.id, className: "input-group-addon input-date" }),
        React.createElement("input", Object.assign({ ref: inputRef, id: props.id, type: "text", required: true, maxLength: 10 }, (props.customValidationMessage ? InputValidationMessage(props.customValidationMessage, inputRef) : {}), { value: inputValue, autoComplete: "off" }, (props.inputProps || {}), { onChange: handleInputChange, className: `form-control ${(_d = (_c = props.inputProps) === null || _c === void 0 ? void 0 : _c.className) !== null && _d !== void 0 ? _d : ''}` }))));
}
